import ComponentList from "~/components/ComponentStatus/ComponentList/ComponentList";
import * as React from 'react';
export default {
  ComponentList,
  React
};